//@flow
import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';

import bgStoreDesktop from '../../../../../../assets/img/home-pages/pop-banner-store-preview-desktop.webp';
import bgStoreMobile from '../../../../../../assets/img/home-pages/pop-banner-store-preview-mobile.webp';

import CustomModal from '../../../../../../elements/CustomModal/CustomModal';
import {colors} from '../../../../../../assets/styles/colors';
import PopupPreview from './PopupPreview';

import type {PopupBanner} from '../../../../../../entities';

type Props = {
  banner: PopupBanner,
  onClose: () => void,
};

const useStyles = makeStyles(theme => ({
  root: {
    height: '90vh',
    marginBottom: '2rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '90vw',
    maxWidth: '1000px',
    maxHeight: '720px',
  },
  title: {
    fontSize: '1rem',
    fontWeight: '600',
    textAlign: 'center',
  },
  contentContainer: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '65% 35%',
    griTemplateRows: '1fr',
    height: '100%',
    gap: '1rem',
  },
  content: {
    height: '100%',
    background: '#F2F2F2',
    borderRadius: '.75rem',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1.5rem 1  rem',
    position: 'relative',
    overflow: 'hidden',
  },
  storeImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '.75rem',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: colors.grey500,
    mixBlendMode: 'multiply',
    zIndex: 1,
  },
  previewWrap: {
    position: 'relative',
    zIndex: 2,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export default function BannerPreview({banner, onClose}: Props) {
  const classes = useStyles();

  return (
    <CustomModal open onClose={onClose}>
      <div className={classes.root}>
        <header>
          <Typography className={classes.title}>
            Previsualización del Banner
          </Typography>
        </header>

        <aside className={classes.contentContainer}>
          <div className={classes.content}>
            <div className={classes.overlay}></div>
            <img
              className={classes.storeImage}
              src={bgStoreDesktop}
              alt="Tienda de ejemplo desktop"
            />
            <div className={classes.previewWrap}>
              <PopupPreview banner={banner} />
            </div>
          </div>
          <div className={classes.content}>
            <div className={classes.overlay}></div>
            <img
              className={classes.storeImage}
              src={bgStoreMobile}
              alt="Tienda de ejemplo mobile"
            />
            <div className={classes.previewWrap}>
              <PopupPreview banner={banner} />
            </div>
          </div>
        </aside>
      </div>
    </CustomModal>
  );
}
